import type { DropdownSeparator } from "./types";

export const separator: DropdownSeparator = { value: "separator" };
